export default __webpack_public_path__ + "static/media/project-in-queue-status.c470c257.svg";